var Accordions = document.querySelectorAll('[js-accordion-wrapper]');

Accordions.forEach((accordion)=>{
    var Toggle = accordion.querySelector('[js-accordion-toggle]');
    var Target = accordion.querySelector('[js-accordion-target]');

    Target.setAttribute('style', 'height:' + Target.offsetHeight + 'px');
    Target.classList.add('init');

    Toggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (Target.classList.contains('open')) {
            Target.classList.remove('open');
            Toggle.classList.remove('open');
            accordion.classList.remove('open');
        } else {
            Target.classList.add('open');
            Toggle.classList.add('open');
            accordion.classList.add('open');
        }
    });
});
